export const SET_REFRESH_ACCOUNT_CONTACT_COLUMNS = 'SET_REFRESH_ACCOUNT_COLUMNS';

export const setRefreshTPAccContactsColumns = (count:number) => ({
    type: SET_REFRESH_ACCOUNT_CONTACT_COLUMNS,
    payload: count
});

const initialState = 0

interface Action {
    type: string;
    payload: number;
  }

const setRefreshTPAccContactsColumnsReducer = (state = initialState, action: Action) => {
    switch (action.type) {
      case SET_REFRESH_ACCOUNT_CONTACT_COLUMNS:
        return action.payload;
  
      default:
        return state;
    }
  };
  export default setRefreshTPAccContactsColumnsReducer;
  